import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ProjectsTasksSection } from './ProjectPlanningDemo';

/** Projects & Tasks tile dialog — project-planning entries, production
 * stages, task assignments, and the link to the real Project Overview,
 * unchanged. */
export default function ProjectsTasksDialog({ open, onOpenChange, goals, strategies, projects, setProjects, tasks, setTasks }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#14171F] border-white/10 text-white sm:max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="projects-tasks-dialog">
        <DialogHeader><DialogTitle className="text-white">Projects & Tasks</DialogTitle></DialogHeader>
        <ProjectsTasksSection
          goals={goals} strategies={strategies}
          projects={projects} setProjects={setProjects}
          tasks={tasks} setTasks={setTasks}
        />
      </DialogContent>
    </Dialog>
  );
}
